import { render, staticRenderFns } from "./ItemFundTransfer.vue?vue&type=template&id=4f507dbc&scoped=true"
import script from "./ItemFundTransfer.vue?vue&type=script&lang=js"
export * from "./ItemFundTransfer.vue?vue&type=script&lang=js"
import style0 from "./ItemFundTransfer.vue?vue&type=style&index=0&id=4f507dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f507dbc",
  null
  
)

export default component.exports